module.exports = __webpack_public_path__ + "static/media/img154.ed5357e7.jpg";